import Reflux from 'reflux';

const RTEActions = Reflux.createActions({
  applyInlineFormatting: {},
});

export default RTEActions;
